import { useCallback, useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import MenuItem from '@mui/material/MenuItem'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/treatments/clinic-fees/style'

/** API */
import ClinicFeeApi from 'api/setting/treatments/clinic-fee.api'

/** UTILS || SLICE */
import { submitModal, unSubmitModal, showModal, resetModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'
import { numberFormat, numberOnly } from 'utils/app.utils'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextField from 'component/Input/InputTextField'
import InputTextSearch from 'component/Input/InputTextSearch'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import FilterSelect from 'component/Select/FilterSelect'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import { Box, Typography } from '@mui/material'
import SwitchButton from 'new-components/buttons/switch-button'
import TextInput from 'new-components/inputs/text-input'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  CLINIC_FEE_NAME: ``,
  IS_DUPLICATE_CLINIC_FEE_NAME: ``,
  CLINIC_FEE_NAME_STRING_BASE: ``,
  CLINIC_FEE_NAME_STRING_EMPTY: ``,
  CLINIC_FEE_NAME_MAXIMUM_LENGTH: ``,
  CLINIC_FEE_NAME_ANY_REQUIRED: ``,

  CLINIC_FEE_NAME_EN: ``,
  IS_DUPLICATE_CLINIC_FEE_NAME_EN: ``,
  CLINIC_FEE_NAME_EN_STRING_BASE: ``,
  CLINIC_FEE_NAME_EN_STRING_EMPTY: ``,
  CLINIC_FEE_NAME_EN_MAXIMUM_LENGTH: ``,
  CLINIC_FEE_NAME_EN_ANY_REQUIRED: ``,

  CLINIC_FEE_PRICE: ``,
  CLINIC_FEE_PRICE_NUMBER_BASE: ``,
  CLINIC_FEE_PRICE_MAXIMUM_LENGTH: ``,
  CLINIC_FEE_PRICE_NUMBER_EMPTY: ``,
  CLINIC_FEE_PRICE_ANY_REQUIRED: ``
}
export default function ClinicFees() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [clinicFees, setClinicFees] = useState([])

  const [clinicFeeId, setClinicFeeId] = useState(Number)
  const [clinicFeeName, setClinicFeeName] = useState('')
  const [clinicFeeNameEn, setClinicFeeNameEn] = useState('')
  const [clinicFeePrice, setClinicFeePrice]: any = useState(Number)
  const [clinicFeeStatus, setClinicFeeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [isAlertDel, setIsAlertDel] = useState<number>(0)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isOpen, setIsOpen] = useState(false)

  const loadData = useCallback(async () => {
    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

    const res = await ClinicFeeApi.findAll(condition)
    if (res.status === 200) {
      setRowCount(res.headers['x-total'])
      setClinicFees(res.data)
    }
  }, [page, pageLimit, search, sortBy, sortType, status])

  useEffect(() => {
    loadData()
  }, [loadData])

  const submit = () => {
    if (!clinicFeeName) return setErrorMessage({ ...errorMessage, ...{ CLINIC_FEE_NAME: t('CLINIC_FEE.MESSAGE.CLINIC_FEE_NAME') } })
    if (clinicFeePrice === '') return setErrorMessage({ ...errorMessage, ...{ CLINIC_FEE_PRICE: t('CLINIC_FEE.MESSAGE.CLINIC_FEE_PRICE') } })

    dispatch(submitModal())
    ClinicFeeApi.create({ clinicFeeName, clinicFeeNameEn, price: clinicFeePrice })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          resetForm()

          loadData()
          setIsOpen(false)
          notiSuccess(t('CLINIC_FEE.MESSAGE.SUCCESS.CREATE'), '', null, null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`CLINIC_FEE.MESSAGE.${err.message}`) } })
          setIsOpen(false)
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`CLINIC_FEE.MESSAGE.${err.message}`) } })
        setIsOpen(false)
      })
  }

  const submitEdit = () => {
    if (!clinicFeeName) return setErrorMessage({ ...errorMessage, ...{ CLINIC_FEE_NAME: t(`CLINIC_FEE.MESSAGE.CLINIC_FEE_NAME`) } })
    if (clinicFeePrice === '') return setErrorMessage({ ...errorMessage, ...{ CLINIC_FEE_PRICE: t('CLINIC_FEE.MESSAGE.CLINIC_FEE_PRICE') } })

    dispatch(submitModal())
    ClinicFeeApi.update(clinicFeeId, {
      clinicFeeName,
      clinicFeeNameEn,
      price: clinicFeePrice,
      status: clinicFeeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          resetForm()
          loadData()
          setIsOpen(false)
          notiSuccess(t(`CLINIC_FEE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`CLINIC_FEE.MESSAGE.${err.message}`) } })
          setIsOpen(false)
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`CLINIC_FEE.MESSAGE.${err.message}`) } })
        setIsOpen(false)
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setClinicFeeId(0)
    setClinicFeeName('')
    setClinicFeeNameEn('')
    setClinicFeePrice(0)
    setClinicFeeStatus('')
    clearErrorMessage()
    setIsOpen(false)
  }

  const onActive = () => {
    if (id) {
      ClinicFeeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('CLINIC_FEE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('CLINIC_FEE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      ClinicFeeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('CLINIC_FEE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('CLINIC_FEE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { clinicFeeId: cfId, clinicFeeName: cfName, clinicFeeNameEn: cfNameEn, price: cfPrice, status: cfStatus } = data
    setClinicFeeId(cfId)
    setClinicFeeName(cfName)
    setClinicFeeNameEn(cfNameEn)
    setClinicFeePrice(cfPrice)
    setClinicFeeStatus(cfStatus)
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'clinicFeeName', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.CLINIC_FEE_NAME') },
    { id: 'clinicFeeNameEn', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.CLINIC_FEE_NAME_EN') },
    { id: 'price', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.CLINIC_FEE_PRICE') },
    { id: 'status', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { clinicFeeId: cfId, clinicFeeName: cfName, clinicFeeNameEn: cfNameEn, price: cfPrice, updatedBy, updatedAt, status: cfStatus } = objData
    const statusBtnActive = cfStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = cfStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled

    const objRenderData = {
      key: cfId,
      id: cfId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: cfName },
        { option: 'TEXT', align: 'left', label: cfNameEn },
        { option: 'TEXT', align: 'right', label: numberFormat(cfPrice) },
        { option: 'STATUS', align: 'center', label: cfStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.clinicFeeName)
    setNameEn(obj.clinicFeeNameEn)
  }

  return (
    <div className={classes.root}>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`CLINIC_FEE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`CLINIC_FEE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { clinicFeeName: name, clinicFeeNameEn: nameEn && `(${nameEn})`, status: t(`CLINIC_FEE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={clinicFeeId ? t('CLINIC_FEE.TITLE_UPDATE') : t('CLINIC_FEE.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('CLINIC_FEE.BUTTON.CANCEL') }}
        onSubmit={{ onClick: clinicFeeId ? submitEdit : submit, title: t('CLINIC_FEE.BUTTON.SAVE') }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          {clinicFeeId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setClinicFeeStatus(clinicFeeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={clinicFeeStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              setClinicFeeName(event.target.value)
              clearErrorMessage()
            }}
            value={clinicFeeName}
            label={t('CLINIC_FEE.INPUT.CLINIC_FEE_NAME')}
            helperText={
              errorMessage.CLINIC_FEE_NAME ||
              errorMessage.IS_DUPLICATE_CLINIC_FEE_NAME ||
              errorMessage.CLINIC_FEE_NAME_STRING_BASE ||
              errorMessage.CLINIC_FEE_NAME_STRING_EMPTY ||
              errorMessage.CLINIC_FEE_NAME_MAXIMUM_LENGTH ||
              errorMessage.CLINIC_FEE_NAME_ANY_REQUIRED
            }
            required
          />
          <TextInput
            onChange={(event) => {
              setClinicFeeNameEn(event.target.value)
              clearErrorMessage()
            }}
            value={clinicFeeNameEn}
            helperText={
              errorMessage.CLINIC_FEE_NAME_EN ||
              errorMessage.IS_DUPLICATE_CLINIC_FEE_NAME_EN ||
              errorMessage.CLINIC_FEE_NAME_EN_STRING_BASE ||
              errorMessage.CLINIC_FEE_NAME_EN_STRING_EMPTY ||
              errorMessage.CLINIC_FEE_NAME_EN_MAXIMUM_LENGTH ||
              errorMessage.CLINIC_FEE_NAME_EN_ANY_REQUIRED
            }
            label={t('CLINIC_FEE.INPUT.CLINIC_FEE_NAME_EN')}
          />
          <TextInput
            numberOnly
            onChange={(event) => {
              setClinicFeePrice(numberOnly(event))
              clearErrorMessage()
            }}
            value={clinicFeePrice}
            helperText={
              errorMessage.CLINIC_FEE_PRICE ||
              errorMessage.CLINIC_FEE_PRICE_NUMBER_BASE ||
              errorMessage.CLINIC_FEE_PRICE_MAXIMUM_LENGTH ||
              errorMessage.CLINIC_FEE_PRICE_NUMBER_EMPTY ||
              errorMessage.CLINIC_FEE_PRICE_ANY_REQUIRED
            }
            label={t('CLINIC_FEE.INPUT.CLINIC_FEE_PRICE')}
            required
          />
        </Box>
      </PageModal>
      <Card className="border-0 h-100">
        <HeaderCard text={t('CLINIC_FEE.TITLE')} />
        <Card.Body>
          <Card.Title className={'mb-0 pl-xl-3'}>
            <Row className="align-items-center">
              <Col md={8}>
                <Row className="flax-row">
                  <Col sm={12} md={6} xl={4} className="pt-2">
                    <InputTextSearch
                      keyInput={'search'}
                      label={t('CLINIC_FEE.SEARCH')}
                      value={search}
                      onchange={(event) => {
                        setSearch(event.target.value)
                        setPage(1)
                      }}
                      onClear={(event) => {
                        setSearch('')
                        setPage(1)
                      }}
                    />
                  </Col>
                  <Col sm={12} md={6} xl={4} className="pl-md-0 pt-2">
                    <FilterSelect
                      onchange={(event) => {
                        const value = event.target.value
                        if (value) {
                          handleChangeStatus(value)
                          setPage(1)
                        }
                      }}
                      renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                      label={t('STATUS.LABEL')}
                      selectId="select-status"
                      value={status}
                      labelId="label-status"
                      options={[
                        <MenuItem key="1" value="ALL">
                          {t('STATUS.ALL')}
                        </MenuItem>,
                        <MenuItem key="2" value="ACTIVE">
                          {t('STATUS.ACTIVE')}
                        </MenuItem>,
                        <MenuItem key="3" value="INACTIVE">
                          {t('STATUS.INACTIVE')}
                        </MenuItem>
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={4} className="mt-2 mt-md-auto">
                <div className="pr-xl-2">
                  <ButtonCustom mode="add" disabled={permissions.isCreate.disabled} onClick={() => setIsOpen(true)} textButton={t('CLINIC_FEE.BUTTON.ADD')} className="w-auto ml-auto d-flex mt-auto" />
                </div>
              </Col>
            </Row>
          </Card.Title>
          <div className={'mt-4 pl-xl-3 pr-xl-2'}>
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              sortType={sortType}
              sortBy={sortBy}
              onSort={onRequestSort}
              setPageLimit={handleChangeRowsPerPage}
              setPage={handleChangePage}
              rowCount={rowCount}
              headCells={headCells}
              rowsData={clinicFees.map((val, i) => {
                return renderData(val, i)
              })}
            />
          </div>
        </Card.Body>
      </Card>

      {/* <ModalCustom
        title={clinicFeeId ? t('CLINIC_FEE.TITLE_UPDATE') : t('CLINIC_FEE.TITLE_CREATE')}
        component={
          <div className="pb-2">
            {clinicFeeId ? (
              <div>
                <Form className="mx-0 mt-0 mb-3 p-0  d-inline-flex w-100">
                  <Form.Label className=" mr-auto">{t('INPUT.LABEL_STATUS')}</Form.Label>
                  <Form.Check type="switch" id="custom-switch" onChange={() => setClinicFeeStatus(clinicFeeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={clinicFeeStatus === 'ACTIVE' ? true : false} style={{ marginLeft: 'auto' }} />
                </Form>
              </div>
            ) : (
              ''
            )}

            <InputTextField
              onchange={(event) => {
                setClinicFeeName(event.target.value)
                clearErrorMessage()
              }}
              value={clinicFeeName}
              label={t('CLINIC_FEE.INPUT.CLINIC_FEE_NAME')}
              helperText={
                errorMessage.CLINIC_FEE_NAME ||
                errorMessage.IS_DUPLICATE_CLINIC_FEE_NAME ||
                errorMessage.CLINIC_FEE_NAME_STRING_BASE ||
                errorMessage.CLINIC_FEE_NAME_STRING_EMPTY ||
                errorMessage.CLINIC_FEE_NAME_MAXIMUM_LENGTH ||
                errorMessage.CLINIC_FEE_NAME_ANY_REQUIRED
              }
              required={true}
              style={{ marginTop: '1rem' }}
            />
            <InputTextField
              key="clinicFeeNameEn"
              onchange={(event) => {
                setClinicFeeNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={clinicFeeNameEn}
              helperText={
                errorMessage.CLINIC_FEE_NAME_EN ||
                errorMessage.IS_DUPLICATE_CLINIC_FEE_NAME_EN ||
                errorMessage.CLINIC_FEE_NAME_EN_STRING_BASE ||
                errorMessage.CLINIC_FEE_NAME_EN_STRING_EMPTY ||
                errorMessage.CLINIC_FEE_NAME_EN_MAXIMUM_LENGTH ||
                errorMessage.CLINIC_FEE_NAME_EN_ANY_REQUIRED
              }
              label={t('CLINIC_FEE.INPUT.CLINIC_FEE_NAME_EN')}
              required={false}
              style={{ marginTop: '1rem' }}
            />
            <InputTextField
              key="clinicFeePrice"
              onchange={(event) => {
                setClinicFeePrice(numberOnly(event))
                clearErrorMessage()
              }}
              value={clinicFeePrice}
              helperText={
                errorMessage.CLINIC_FEE_PRICE ||
                errorMessage.CLINIC_FEE_PRICE_NUMBER_BASE ||
                errorMessage.CLINIC_FEE_PRICE_MAXIMUM_LENGTH ||
                errorMessage.CLINIC_FEE_PRICE_NUMBER_EMPTY ||
                errorMessage.CLINIC_FEE_PRICE_ANY_REQUIRED
              }
              label={t('CLINIC_FEE.INPUT.CLINIC_FEE_PRICE')}
              required={true}
              style={{ marginTop: '1rem' }}
            />
          </div>
        }
        onReset={resetForm}
        onSubmit={clinicFeeId ? submitEdit : submit}
        textBtnCancel={t('CLINIC_FEE.BUTTON.CANCEL')}
        textBtnConfirm={t('CLINIC_FEE.BUTTON.SAVE')}
      /> */}
    </div>
  )
}
